import React, { useMemo, lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';

// Contexto para cargar dinámicamente cualquier archivo *Catalog.jsx dentro de src/components/
const CTX = require.context('../', true, /.*Catalog\.(jsx|tsx)$/);

function toContextKey(dbPath) {
    if (!dbPath) return "";
    let p = String(dbPath).trim();

    // Normalizar la ruta para que coincida con las claves del contexto (./Subdir/File.jsx)
    // Generalmente en BD vienen como "../Seguridad/..." o "Seguridad/..."
    p = p.replace(/^\.\.\//, "./");
    if (!p.startsWith("./")) p = "./" + p.replace(/^\/+/, "");

    return p;
}

export default function DynamicCatalogPage() {
    const [searchParams] = useSearchParams();
    const path = searchParams.get('path');

    const ActiveCatalog = useMemo(() => {
        if (!path) return null;
        const key = toContextKey(path);

        // Verificar si el archivo existe en el contexto
        if (!CTX.keys().includes(key)) {
            console.error(`[DynamicCatalogPage] Catálogo no encontrado: ${path} (Clave generada: ${key})`);
            console.log('Claves disponibles:', CTX.keys());
            return null;
        }

        // Lazy import del módulo encontrado
        return lazy(() => Promise.resolve(CTX(key)));
    }, [path]);

    if (!path) {
        return <div style={{ padding: 20 }}>No se especificó un catálogo.</div>;
    }

    if (!ActiveCatalog) {
        return (
            <div style={{ padding: 20, color: 'red' }}>
                <h3>Error 404: Catálogo no encontrado</h3>
                <p>Ruta solicitada: {path}</p>
                <p>Verifique que el archivo termine en "Catalog.jsx" y esté dentro de la carpeta components.</p>
            </div>
        );
    }

    return (
        <Suspense fallback={<div style={{ padding: 20 }}>Cargando catálogo...</div>}>
            <ActiveCatalog key={path} />
        </Suspense>
    );
}
